<template>
  <div class="ps-3 form-section__group__field">
    <div class="form-group border-start p-3 border-primary">
      <div class="row g-3">
        <div class="col-md-12">
          <!-- <textarea v-model="answer.medicalDeclarationAdditional" class="form-control" rows="4" cols="30"> </textarea> -->
          <AppInput
            :name="`answer.additionalInformation_${index}`"
            :label="$root.t('step4.additionalInformation')"
            rules="required"
          >
            <Input
              :id="`answer.additionalInformation_${index}`"
              v-model="answer.medicalDeclarationAdditional"
              multiline
              class-name="form-control"
            />
          </AppInput>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerAdditionalForm',
  components: {},
  props: {
    answer: { type: Object, required: true },
    index: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
